module.exports = __webpack_public_path__ + "e-learning-app/static/img/1.5b5bee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.png
// module id = A1tS
// module chunks = 1